module.exports = __webpack_public_path__ + "img/pic_zoo_S.81a3fc20.jpg";